
import { Box, Chip, Stack, Typography } from "@mui/material";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import { formatDate, labelSx, sectionTitleSx, valueSx } from "./styles";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const clean = (value: any) => {
    if (value === null || value === undefined) return "";
    const trimmed = String(value).trim();
    if (!trimmed) return "";
    const lower = trimmed.toLowerCase();
    if (lower === "null" || lower === "undefined" || lower === "n/a" || lower === "na") return "";
    return trimmed;
};

const STATUS_META: Record<string, { bg: string; color: string; label: string }> = {
    final: { bg: "#d3f0e9", color: "#2d6a4f", label: "Final" },
    amended: { bg: "#e0f2fe", color: "#0369a1", label: "Amended" },
    preliminary: { bg: "#fff3e0", color: "#ad6800", label: "Preliminary" },
    cancelled: { bg: "#fde7ef", color: "#c62828", label: "Cancelled" },
    "entered-in-error": { bg: "#fde7ef", color: "#c62828", label: "Entered in error" }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CompositionHeader = ({ composition }: { composition: any }) => {
    const rawStatus = clean(composition?.status);
    const statusKey = rawStatus.toLowerCase();
    const statusMeta = STATUS_META[statusKey] || { bg: "#eceef2", color: "#5b6778", label: rawStatus || "Unknown" };

    const bundleLabel = clean(composition?.typeText) || clean(composition?.bundleType) || "Composition";
    const date = formatDate(composition?.date);

    return (
        <Box
            sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: "#ffffff",
                border: "2px solid #f0f0f0",
                boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
                mb: 2,
                position: "relative",
                "&::before": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: "5px",
                    background: "linear-gradient(180deg, #2fbf71 0%, #27a864 100%)",
                    borderRadius: "3px 0 0 3px"
                }
            }}
        >
            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ ml: 1, mb: 2 }}>
                <Box
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 2,
                        bgcolor: "#d3f0e9",
                        color: "#2d6a4f",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <EventNoteOutlinedIcon sx={{ fontSize: 22 }} />
                </Box>
                <Typography sx={{ ...sectionTitleSx, mb: 0 }}>Composition</Typography>
            </Stack>
            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems={{ xs: "flex-start", sm: "center" }}
                justifyContent="space-between"
                sx={{ ml: 1 }}
            >
                <Stack direction="row" spacing={1.25} alignItems="center" flexWrap="wrap" useFlexGap>
                    <Typography
                        sx={{
                            fontWeight: 800,
                            fontSize: "1.15rem",
                            color: "#1f3a2e",
                            textTransform: "uppercase",
                            letterSpacing: 0.6
                        }}
                    >
                        {bundleLabel}
                    </Typography>
                    {rawStatus ? (
                        <Chip
                            size="small"
                            icon={<VerifiedOutlinedIcon sx={{ fontSize: 16, color: `${statusMeta.color} !important` }} />}
                            label={statusMeta.label}
                            sx={{
                                bgcolor: statusMeta.bg,
                                color: statusMeta.color,
                                fontWeight: 800,
                                letterSpacing: 0.4,
                                border: `1px solid ${statusMeta.color}33`,
                                px: 0.5
                            }}
                        />
                    ) : null}
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography sx={labelSx}>Date</Typography>
                    <Typography sx={valueSx}>{date}</Typography>
                </Stack>
            </Stack>
        </Box>
    );
};

export default CompositionHeader;
